import axios from "axios";
import setupInterceptors from "./interceptors";

const apiBaseEsupplyvet = axios.create({
  baseURL: process.env.VUE_APP_API_BACK_URL_ESUPPLYVET,
  headers: {
    "Content-Type": "application/json",
    accept: "application/json",
  },
});

// Injecte token + gestion erreurs
setupInterceptors(apiBaseEsupplyvet);

export default apiBaseEsupplyvet;
